import { Grid } from '@material-ui/core'
import { Accordion } from 'shared/components/Accordion/Accordion'
import { Card } from 'shared/components/Base/Base'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Button } from 'shared/components/Button/Button'
import { DropdownWithSearchOption } from 'shared/components/Dropdown/DropdownWithSearchOption'
import { Text } from 'shared/components/Text/Text'
import { HandlerOf } from 'shared/helpers/typeHelper'
import { sizes } from 'shared/theme'
import { bgGray, lightGray1, primaryBlack } from 'shared/theme/colors'

import { VendorProgram } from '../../models/repayments'

export function PolicyFormPolicyPicker({
  secondStep,
  vendorPrograms,
  activeVendorProgramName,
  setActiveVendorProgramName,
  onNext,
  isDisabled,
  setSecondStep,
}: {
  secondStep: boolean
  vendorPrograms: VendorProgram[]
  activeVendorProgramName: VendorProgram['name'] | undefined
  setActiveVendorProgramName: HandlerOf<VendorProgram['name']>
  onNext: () => void
  isDisabled?: boolean
  setSecondStep?: HandlerOf<boolean>
}) {
  return (
    <Card>
      <FlexBox>
        <Accordion
          isExpanded={!secondStep}
          // disable the accordion if the user is editing a policy or if there is no vendor program selected
          isDisabled={isDisabled || !activeVendorProgramName || !secondStep}
          // when clicking on this close the second step (Deduction details)
          onClick={(isExpanded) => isExpanded && setSecondStep?.(false)}
          details={
            <Grid>
              <FlexBox isColumn alignItems="stretch" mt={4} gap="20px">
                <FlexBox alignItems="flex-start">
                  <DropdownWithSearchOption
                    label="Select deduction"
                    options={vendorPrograms.map((v) => ({ value: v.name, label: v.name }))}
                    value={activeVendorProgramName}
                    onChange={setActiveVendorProgramName as HandlerOf<any>}
                    isDisabled={isDisabled}
                    backgroundColor={bgGray}
                    isFullWidth
                    noMargin
                    maxHeight={800}
                  />
                </FlexBox>

                <FlexBox justifyContent="flex-end" alignItems="center" gap="20px">
                  <Button size={sizes.large} onClick={onNext} isDisabled={!activeVendorProgramName}>
                    NEXT
                  </Button>
                </FlexBox>
              </FlexBox>
            </Grid>
          }
        >
          {() => (
            <FlexBox justifyContent="flex-start" alignItems="center">
              <Text variant="header2" style={{ color: secondStep ? lightGray1 : primaryBlack }}>
                Deduction type
              </Text>
              {activeVendorProgramName && secondStep && (
                <Text variant="header3" style={{ marginLeft: 16 }}>
                  {activeVendorProgramName}
                </Text>
              )}
            </FlexBox>
          )}
        </Accordion>
      </FlexBox>
    </Card>
  )
}
